import React from 'react';
import { useApi } from '@backstage/core-plugin-api';
import { Entity } from '@backstage/catalog-model';
import { computeResourceDiscoveryApiRef } from '../../api';
import { AwsContextProvider } from './AwsContext';
import { Aws } from './Aws';
import { useEntity } from '@backstage/plugin-catalog-react';
import { Alert } from '@mui/material';
import { CRDAWSConfig } from '@internal/backstage-plugin-compute-resource-discovery-new-common';

type AwsWithProvidersProps = {
  projectCode: string;
  awsConfigs: CRDAWSConfig[] | undefined;
};

export const AwsWithProviders: React.FC<AwsWithProvidersProps> = ({
  projectCode,
  awsConfigs,
}) => {
  const { entity } = useEntity<Entity>();
  const api = useApi(computeResourceDiscoveryApiRef);

  if (!awsConfigs || awsConfigs.length === 0) {
    return (
      <Alert severity="warning" sx={{ my: 2 }}>
        AWS configuration not found for project code {projectCode}
      </Alert>
    );
  }

  return (
    <AwsContextProvider
      api={api}
      awsConfigs={awsConfigs}
      projectCode={projectCode}
    >
      <Aws entity={entity} />
    </AwsContextProvider>
  );
};
